import { useI18n } from "vue-i18n";
/**
 * Resolve a localized label for a {@link ConsentPurpose}.
 *
 * Resolution order: the translation for the given locale (short form, e.g. "fr"
 * derived from "fr-FR") → English fallback → the raw purpose `code`.
 *
 * @param purpose The consent purpose to label.
 * @param locale  The active i18n locale (full or short, e.g. "fr-FR" or "fr").
 */
export function resolveConsentPurposeLabel(purpose, locale) {
    const current = locale.slice(0, 2);
    const match = purpose.translations.find((translation) => translation.locale === current) ??
        purpose.translations.find((translation) => translation.locale === "en");
    return match?.label || purpose.code;
}
/**
 * Composable exposing a locale-aware {@link ConsentPurpose} label resolver bound
 * to the current vue-i18n locale (active locale → English → `code`).
 */
export function useConsentPurposeLabel() {
    const { locale } = useI18n();
    function resolveLabel(purpose) {
        return resolveConsentPurposeLabel(purpose, locale.value);
    }
    return { resolveLabel };
}
